export default "__VITE_PUBLIC_ASSET__c3af69cd__"